import React from "react";
import { createPortal } from "react-dom";

// Logout/confirmation modal: portaled to document.body so it escapes parent stacking contexts;
// uses highest z-index (999999) so it always appears on top of nav, overlays, and other modals.
const Modal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  const modalContent = (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[999999]" aria-modal="true" role="dialog" aria-labelledby="modal-title">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 id="modal-title" className="text-lg font-semibold text-gray-900">{title}</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        {children}
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default Modal;
